import { Navigate, useSearchParams } from 'react-router-dom'
import { usePedagogyAccess } from '@/hooks/usePedagogyAccess'
import { useSuperAdmin } from '@/hooks/useSuperAdmin'
import { PedagogyReviewDistributionReport } from '@/pages/PedagogyReviewDistributionReport'
import { PedagogyReviewQueueForecastPage } from '@/pages/PedagogyReviewQueueForecastPage'
import { PedagogyReviewSkipInsightsPage } from '@/pages/PedagogyReviewSkipInsightsPage'
import { Card } from '@/components/ui'
import { pedagogyPaths } from '@/lib/pedagogyRoutes'

type InsightMode = 'queue' | 'distribution' | 'skips'

export function PedagogyReviewDistributionPage() {
  const [params, setParams] = useSearchParams()
  const { canManagePedagogy } = usePedagogyAccess()
  const { isSuperAdmin } = useSuperAdmin()
  const canViewInsights = canManagePedagogy || isSuperAdmin === true
  if (!canViewInsights && isSuperAdmin === undefined) {
    return <Card><div className="py-10 text-center text-sm text-muted-foreground">Проверяем доступ…</div></Card>
  }
  if (!canViewInsights) {
    return <Navigate to={pedagogyPaths.department} replace />
  }

  const requestedMode = params.get('mode') as InsightMode | null
  const mode: InsightMode = requestedMode === 'distribution' || requestedMode === 'skips'
    ? requestedMode
    : canViewInsights
      ? 'queue'
      : 'distribution'

  const setMode = (nextMode: InsightMode) => {
    const next = new URLSearchParams(params)
    next.set('mode', nextMode)
    next.delete('view')
    next.delete('skipView')
    setParams(next, { replace: true })
  }

  return (
    <div className="space-y-4 pb-12">
      {canViewInsights && <div className="flex gap-5 overflow-x-auto border-b border-border" role="tablist" aria-label="Раздел анализа отсмотров">
        <button type="button" role="tab" aria-selected={mode === 'queue'} onClick={() => setMode('queue')} className={`shrink-0 border-b-2 px-0.5 pb-2.5 pt-1 text-sm font-medium transition-colors ${mode === 'queue' ? 'border-primary text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>Очередь отсмотров</button>
        <button type="button" role="tab" aria-selected={mode === 'distribution'} onClick={() => setMode('distribution')} className={`shrink-0 border-b-2 px-0.5 pb-2.5 pt-1 text-sm font-medium transition-colors ${mode === 'distribution' ? 'border-primary text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>Распределение отсмотров</button>
        <button type="button" role="tab" aria-selected={mode === 'skips'} onClick={() => setMode('skips')} className={`shrink-0 border-b-2 px-0.5 pb-2.5 pt-1 text-sm font-medium transition-colors ${mode === 'skips' ? 'border-primary text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>Пропуски и доступы</button>
      </div>}

      {mode === 'queue'
        ? <PedagogyReviewQueueForecastPage />
        : mode === 'skips'
          ? <PedagogyReviewSkipInsightsPage />
          : <PedagogyReviewDistributionReport embedded />}
    </div>
  )
}
